import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/img/logo.png"; // Adjust path as needed
import profileicon from "../../../assets/img/profile-icon.png"; // Adjust path as needed

const ClientNavbar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear(); // Clears all stored data
    navigate("/login", { replace: true }); // Redirects to login and prevents back navigation
    window.history.pushState(null, "", window.location.href);
  
    window.onpopstate = function () {
      setTimeout(() => {
        navigate("/login", { replace: true });
        window.history.pushState(null, "", window.location.href); // Keep trapping
      }, 1500); // 1.5s delay for back/forward
    };
  
  
  };
  
  return (
    <Navbar
      bg="white"
      variant="light"
      className="container-fluid"
      sticky="top"
      expand="lg"
      style={{
        padding: "0px 10px",
        borderBottom: "0.5px solid lightgray",
        width: "auto",
      }}
    >
      {/* Brand Logo */}
      <Navbar.Brand href="/">
        <img
          src={logo}
          alt="Logo"
          width="70"
          height="70"
          className="d-inline-block align-top"
        />
      </Navbar.Brand>

      {/* Navbar Toggle for Mobile */}
      <Navbar.Toggle aria-controls="navbar-nav" />

      {/* Navbar Content */}
      <Navbar.Collapse id="navbar-nav" className="justify-content-end">
        <Nav>
          <Nav.Link href="/client/clientdashboard" className="text-black ml-2 pr-4">
            Home
          </Nav.Link>
          <Nav.Link href="/client/clientCounsellorList" className="text-black ml-2 pr-4">
            Counsellors
          </Nav.Link>
        </Nav>

        {/* Logout Button */}
        <Button variant="danger" size="md" onClick={handleLogout}>
          Logout
        </Button>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <img
          src={profileicon}
          alt="Profile"
          width="55"
          height="55"
          className="d-inline-block align-top"
        />
      </Navbar.Collapse>
    </Navbar>
  );
};

export default ClientNavbar;
